import {
  DonationNavBarMobileContainer,
  DonationNavBarMobileRow, 
  BorderLine,
} from './DonationNavBarMobile.styles';
import {
  DonationNavBarUserInfo, 
  DonationNavBarLogoRow, 
  DonationBenevPay,
  DonationNavBarLogo,
  DonationNavBarAccount,
} from '../DonationNavBar/DonationNavBar.styles';
import { useAppSelector } from "store/hooks";
import { DefaultTextBold, DefaultTextLight, GreyTextBold, GreyTextLight } from "components/text/Text";
import Images from 'config/Images';
import UserAvatar from 'components/images/UserAvatar/UserAvatar';

function DonationNavBarMobile() {
  const user = useAppSelector(state => state.user);

  return (
    <DonationNavBarMobileContainer>
      <DonationNavBarMobileRow>
        <DonationNavBarLogoRow>
          <DonationNavBarLogo src={Images.benevvLogo}/>
          <DonationBenevPay>
            <DefaultTextBold>BENEV</DefaultTextBold>
          </DonationBenevPay>
          <DonationBenevPay>
            <DefaultTextLight>Pay</DefaultTextLight>
          </DonationBenevPay>
        </DonationNavBarLogoRow>
        <DonationNavBarUserInfo>
          <UserAvatar image={user.socialAvatarUrl}/>
          <DonationNavBarAccount>
            <GreyTextBold>{user.name}</GreyTextBold>
          </DonationNavBarAccount> 
          <DonationNavBarAccount>
            <GreyTextLight>Donation Account</GreyTextLight>
          </DonationNavBarAccount>
        </DonationNavBarUserInfo>
      </DonationNavBarMobileRow>
      <BorderLine/>
    </DonationNavBarMobileContainer>
  )
}

export default DonationNavBarMobile;
